import type { MantineColorShade } from "@mantine/core";
import { DEFAULT_COLORS } from "./default-colors";

export const SE_THEME = {
    colorScheme: "light",
    white: "#fff",
    black: "#000",
    colors: DEFAULT_COLORS,
    fontFamily: `'siemens', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto,Ubuntu, Cantarell, Noto Sans, sans-serif, Helvetica Neue, Arial,Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji`,
    defaultGradient: {
        from: "#1B1534",
        to: "#4D217A",
        deg: 45,
    },
    defaultRadius: "lg",
    primaryColor: "purple",
    primaryShade: 6 as MantineColorShade,
    components: {
        Modal: {
            defaultProps: {
                padding: "xl",
                centered: true,
            },
            styles: {
                title: {
                    fontSize: "1.2rem",
                    fontWeight: 600,
                },
            },
        },
        Overlay: {
            defaultProps: {
                opacity: 0.6,
                blur: 6,
            },
        },
        ActionIcon: {
            defaultProps: {
                variant: "subtle",
            },
        },
        ThemeIcon: {
            defaultProps: {
                variant: "subtle",
            },
        },
        Code: {
            styles: (theme) => ({
                root: {
                    fontSize: theme.fontSizes.sm,
                    backgroundColor:
                        theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[1],
                },
            }),
        },
    },
};
